import React from "react";
import {
    EmailShareButton,
    FacebookShareButton,
    LinkedinShareButton,
    TelegramShareButton,
    TwitterShareButton,
    WhatsappShareButton,
} from "react-share";

function Share({ url }) {

    const [active, setActive] = React.useState(false)

    const handleClick = () => {
        setActive(!active)
    }

    return (
        <div className="social-media-container">
            <div className="share-container">
                <i  onClick={handleClick}
                    className={`fa-solid ${active ? 'fa-xmark' : 'fa-share-nodes'}`}
                    title={active ? 'Cerrar' : 'Compartir'}></i>
            </div>
            <div className={`social-share ${active ? 'active' : ''}`}>
                <FacebookShareButton url={url} >
                    <i className="fa-brands fa-facebook-f" title="Facebook"></i>
                </FacebookShareButton>
                <TwitterShareButton url={url} >
                    <i className="fa-brands fa-x-twitter" title="X"></i>
                </TwitterShareButton>
                <EmailShareButton url={url} >
                    <i className="fa-solid fa-envelope" title="Email"></i>
                </EmailShareButton>
                <WhatsappShareButton url={url}>
                    <i className="fa-brands fa-whatsapp" title="Whatsap"></i>
                </WhatsappShareButton>
                <TelegramShareButton url={url}>
                    <i className="fa-brands fa-telegram" title="Telegram"></i>
                </TelegramShareButton>
                <LinkedinShareButton url={url}>
                    <i className="fa-brands fa-linkedin-in" title="Linkedin"></i>
                </LinkedinShareButton>
            </div>
        </div>
    )
}

export { Share }